import { apiRequest } from './client';

// Public
export const listCurrencies = (signal) => apiRequest('/api/currencies', { signal });

export const saveCurrencyPreference = (token, currency) =>
  apiRequest('/api/auth/me/preferences', { method: 'PUT', body: { currency }, token });

// Admin
export const adminListCurrencies = (token) => apiRequest('/api/admin/currencies', { token });

export const adminSaveCurrency = (token, code, currency) =>
  apiRequest(`/api/admin/currencies/${code}`, { method: 'PUT', body: currency, token });

export const adminDeleteCurrency = (token, code) =>
  apiRequest(`/api/admin/currencies/${code}`, { method: 'DELETE', token });
